// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb-module--wrapper--WvWlH","container":"Breadcrumb-module--container--3NCJO","link":"Breadcrumb-module--link--1rMxz"};